angular.module('core')
  .service('dblProficiencyApi', [
        '$log',
        '$q',
        'dblAstApi',
        'cancelableResourceFactory',
        'cancelableResourceManager',
        'dblStudentStandardsApi',
    function (
        $log,
        $q,
        dblAstApi,
        dblCancelableResourceFactory,
        dblCancelableResourceManager,
        dblStudentStandardsApi) {

    var StudentDomainProficiency = dblCancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/students/:studentId/proficiency/domains', {}, {
      get: {
        url: '/r/districts/:districtId/students/:studentId/proficiency/domains',
        method: 'GET',
        isArray: false
      }
    });

    var injectTestData = function (startingProficiency, endingProficiency) {
        var endPlacement = Math.random() < 0.3 ? 0 : (Math.random() > 0.9 ? 1 : Math.random() * 0.45);
        var theRest = 1 - endPlacement;
        var a = Math.random() < 0.2 ? 0 : (Math.random() > 0.7 ? theRest : theRest * Math.random());
        var b = (1 - a - endPlacement) * Math.random();
        var startPlay = Math.min(a, b);
        var endPlay = Math.max(a, b);
        endingProficiency.mos_passed_by_play_count = endingProficiency.mo_count * endPlay;
        endingProficiency.mos_passed_by_placement_count = endingProficiency.mo_count * endPlacement;
        startingProficiency.mos_passed_by_play_count = endingProficiency.mo_count * startPlay;
    };

    var createCell = function (level, domain, standardsForGrade, startingProficiency, endingProficiency) {
        var cell = {};
        if (endingProficiency) {
            // injectTestData(startingProficiency, endingProficiency);

            cell.grade = level.grade;
            cell.standards_count = endingProficiency.standards_count;
            cell.standards_completed = endingProficiency.standards_completed;
            cell.percentStandardsComplete = 100 * endingProficiency.standards_completed / endingProficiency.standards_count;

            cell.moPlacementPercent = 100 * endingProficiency.mos_passed_by_placement_count / endingProficiency.mo_count;

            var totalMosAtEnd = endingProficiency.mos_passed_by_placement_count + endingProficiency.mos_passed_by_play_count;

            var playMoGrowth = 0;

             if (startingProficiency) {
                // Calculate play growth making sure it's never negative
                playMoGrowth = Math.max(0, endingProficiency.mos_passed_by_play_count - startingProficiency.mos_passed_by_play_count);
                cell.playMoGrowthPercent = 100 * playMoGrowth;
            }

            cell.moStartOfGrowthPercent = 100 * (totalMosAtEnd - playMoGrowth) / endingProficiency.mo_count;
            cell.moEndOfGrowthPercent = 100 * totalMosAtEnd / endingProficiency.mo_count;

            // In current G2 implementation end of growth and ending proficiency are the same, but in the future
            // end of growth will be maximal proficiency in the date range of the data
            cell.moProficiencyPercent = cell.moEndOfGrowthPercent;
        }

        if (standardsForGrade) {
            cell.standards = standardsForGrade.standardsForDomainByCode[domain.code];
        }

        return cell;
    };

    var buildStudentDomainTable = function(ast, startingDomainProficiencies, endingDomainProficiencies, allStandardsLevels) {
        var startingProficiencyById = _.indexBy(startingDomainProficiencies, 'id');
        var endingProficiencyById = _.indexBy(endingDomainProficiencies, 'id');

        // build lookup into standards proficiency
        var allStandardsByGrade = _.indexBy(allStandardsLevels, 'grade');
        _.each(allStandardsByGrade, function (standardsForGrade) {
            standardsForGrade.standardsForDomainByCode = _.indexBy(standardsForGrade.domains, 'code');
        });

        var MAX_GRADE = 8;

        var columns = {};
        var domainsById = {};
        var rows = {};
        _.each(ast.children, function (level) {
            if (level.grade > MAX_GRADE) {
                return;
            }

            var column = {
                grade: level.grade,
                standards_completed: 0,
                standards_count: 0
            };

            columns[level.code] = column;

            var standardsForGrade = allStandardsByGrade[level.grade];
            if (standardsForGrade) {
              column.standards_completed = standardsForGrade.standards_completed;
              column.standards_count = standardsForGrade.standards_count;
            }

            _.each(level.children, function (domain) {
                if (!rows[domain.name]) {
                    rows[domain.name] = {
                        name: domain.name,
                        ordinal: domain.ordinal,
                        levelsById: {}
                    };
                }

                var row = rows[domain.name];
                row.ordinal = Math.min(row.ordinal, domain.ordinal);

                var endingProficiency = endingProficiencyById[domain.code];
                var startingProficiency = startingProficiencyById[domain.code];

                // these should be defined; if not it's a back end bug
                if (!endingProficiency || !startingProficiency) {
                    // TODO: non-angular logging lib
                    $log.error('Invalid proficiency data.');
                }

              if (!standardsForGrade) {
                column.standards_completed += endingProficiency.standards_completed;
                column.standards_count += endingProficiency.standards_count;
              }

                var cell = createCell(level, domain, standardsForGrade, startingProficiency, endingProficiency);

                rows[domain.name].levelsById[level.grade] = cell;
            });

        });

        _.each(rows, function (row) {
            row.levels = [];

            var previousCell;
            _.each(columns, function (column) {
                var cell;
                if (row.levelsById[column.grade]) {
                    cell = row.levelsById[column.grade];
                } else {
                    // create cell where domain doesn't exist for level
                    cell = {
                        grade: column.grade
                    };
                }

                // indicate if growth was continuous across consecutive domains
                if (previousCell && previousCell.moProficiencyPercent === 100 && cell.moProficiencyPercent > 0 && cell.moStartOfGrowthPercent === 0) {
                    cell.growthContinuedFromPrevious = true;
                    previousCell.growthContinuedToNext = true;
                }

                row.levels.push(cell);
                previousCell = cell;
            });

        });

        return {
            astName: ast.name,
            columns: _.values(columns),
            rows: _.sortBy(_.values(rows), 'ordinal')
        };
    };

    var getStudentDomainTable = function (districtId, studentId, ast, days, sy, fd, td, includesThePresent, loadStandards) {
        var params = {
            districtId: districtId,
            studentId: studentId,
            untilNow: true,
            sy: sy,
            fd: fd,
            td: td
        };

        if (!fd && !td) {
            params.days = days;
        }

        var astPromise = dblAstApi.getAst(ast, params.days, sy, fd, td);

        var resource = StudentDomainProficiency.get(params);
        dblCancelableResourceManager.addAndRemoveOnFinish(resource);

        var promises = {
            ast: astPromise,
            studentDomains: resource.$promise,
        };

        if (includesThePresent && loadStandards) {
            var isAstDbl = ast === 'dbl';
            var standardsAllPromise = dblStudentStandardsApi.getStudentAll(districtId, studentId, null, isAstDbl);

            promises.standardsAll = standardsAllPromise;
        }

        return $q.all(promises).then(function (results) {
            var ast = results.ast.data;
            var startingDomainProficiencies = results.studentDomains.data.starting_proficiencies;
            var endingDomainProficiencies = results.studentDomains.data.ending_proficiencies;
            var currentAllStandardsProficiencies = results.standardsAll;
            var allStandardsLevels;

            if (currentAllStandardsProficiencies) {
                allStandardsLevels = currentAllStandardsProficiencies.levels;
            }

            return buildStudentDomainTable(ast, startingDomainProficiencies, endingDomainProficiencies, allStandardsLevels);
        });
    };

    this.buildStudentDomainTable = buildStudentDomainTable;
    this.getStudentDomainTable = getStudentDomainTable;
}]);
